<script setup lang="ts">
import type { Option } from '~/types'

interface Props {
  label?: string
  options: Option[]
  id?: string
  disabled?: boolean
  isLight?: boolean
}

defineProps<Props>()
const model = defineModel<string | number>()
</script>

<template>
  <div
    class="dropdown"
    :class="{ 'dropdown--light': isLight }"
    :data-before="label"
  >
    <label
      v-if="label"
      :for="id"
      class="sr-only"
    >
      {{ label }}
    </label>
    <select
      :id="id"
      v-model="model"
      class="dropdown__select"
      :name="id"
      :disabled="disabled"
    >
      <slot name="option-all" />
      <option
        v-for="(option, index) in options"
        :key="index"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<style scoped lang="scss">
.dropdown {
  &__select {
    @apply bg-white pl-5 pr-8 h-11 rounded-full border border-primary/20 min-w-[140px] text-[16px] font-medium text-primary/70 appearance-none cursor-pointer bg-chevron bg-no-repeat bg-[length:14px_8px] bg-[calc(100%-15px)_center];
    @apply md:min-w-[200px];
  }

  &--light &__select {
    @apply bg-primary text-white border-white/20 bg-chevron-light;
  }
}
</style>
